import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./introduce.scss"
import { Link } from 'react-router-dom';

const IntroduceFreelancer = () => {

  const client_Id = localStorage.getItem("client_Id");
  const recuiterId = localStorage.getItem("recuiter_Id");
  var settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    // fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    fade: true,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 3000,
    cssEase: "linear"

  };
  const whychooseNbf = [
    { img: "icon/Vector (1).png", tagline: "Secure Payments", content: "All funds are safeguarded until you are fully satisfied with the freelancer's work. Our secure payment system ensures safety and trust for both parties" },
    { img: "icon/Vector (1).png", tagline: "One-on-One Interaction", content: "One-on-One Interaction with freelancers plays a crucial role in building trust, ensuring clear communication, and achieving successful project outcomes" },
    { img: "icon/Vector (1).png", tagline: "Same Timezones", content: "Working with freelancers who share the same office hours promotes a collaborative work environment and enables them to attend team meetings just like regular employees" },
    { img: "icon/Vector (1).png", tagline: "Top Rated Freelancers", content: "We focus on providing high-quality freelancers to ensure a specialised skill set, greater dedication, and efficient collaboration for your project" },
    // { img: "icon/Component 5 (3).png", tagline: "One-on-One Interaction" },
    // { img: "icon/Component 5 (2).png", tagline: "Efficient Hiring" },
    // { img: "icon/Component 5.png", tagline: "Unlimited Job Postings" },

    // { img: "icon/Component 5 (1).png", tagline: "Higher Retention" },
    // { img: "icon/Vector.png", tagline: "Direct Hiring Tool" },

  ]

  return (
    <>
      {client_Id ? (
        <div className="why-should-nbf">
          <div className="why-should-nbf-container">
            <h4>Why Should I Use NearbyFreelancers?</h4>
            <p>Here are the Advantages of Choosing a NearbyFreelancer 
              {/* <br /> */}
              {/* Explore the unique benefits of choosing nearby freelancers for all your freelancing needs */}
              </p>

            <div className="why-should-nbf-content">
              <div className="why-should-nbf-content-img"><img src="/image/findcardimg1.webp" alt="" /></div>
              <div className="why-should-nbf-content-img why-should-nbf-content-inner ">
                <h5>Secure Payments</h5>
                <p>
                  All funds are safeguarded until you are fully satisfied with the freelancer's work. Our secure payment system ensures safety and trust for both parties
                </p>
              </div>
              <div className="why-should-nbf-content-img"><img src="/svg/why2.webp" alt="" /></div>
              <div className="why-should-nbf-content-img why-should-nbf-content-inner">
                <h5>One-on-One</h5>
                <p>
                  One-on-One Interaction with freelancers plays a crucial role in building trust, ensuring clear communication, and achieving successful project outcomes
                </p>
              </div>
              <div className="why-should-nbf-content-img why-should-nbf-content-inner">
                <h5>Same Time zones</h5>
                <p>
                  Working with freelancers who share the same office hours promotes a collaborative work environment and enables them to attend team meetings just like regular employees
                  {/* One-on-One Interaction with freelancers plays a crucial role in building trust, ensuring clear communication, and achieving successful project outcomes */}
                </p>
              </div>
              <div className="why-should-nbf-content-img"><img src="/svg/why3.webp" alt="" /></div>
              <div className="why-should-nbf-content-img why-should-nbf-content-inner">
                <h5>Top Rated Freelancers</h5>
                <p>
                  We focus on providing high-quality freelancers to ensure a specialised skill set, greater dedication, and efficient collaboration for your project
                  {/* One-on-One Interaction with freelancers plays a crucial role in building trust, ensuring clear communication, and achieving successful project outcomes */}
                </p>
              </div>
              <div className="why-should-nbf-content-img"><img src="/svg/why4.webp" alt="" /></div>

            </div>

          </div>
        </div>
      ) : recuiterId ? (
        null
      ) : (
        <div className="why-should-nbf">
          <div className="why-should-nbf-container">
            <h4>Why Should I Use NearbyFreelancers?</h4>
            <p>Here are the Advantages of Choosing a NearbyFreelancer 
              <br />
              {/* Explore the unique benefits of choosing nearby freelancers for all your freelancing needs */}
              </p>

            <div className="why-should-nbf-content">
              <div className="why-should-nbf-content-img"><img src="/image/findcardimg1.webp" alt="" /></div>
              <div className="why-should-nbf-content-img why-should-nbf-content-inner ">
                <h5>Secure Payments</h5>
                <p>
                  All funds are safeguarded until you are fully satisfied with the freelancer's work. Our secure payment system ensures safety and trust for both parties
                </p>
              </div>
              <div className="why-should-nbf-content-img"><img src="/svg/why2.webp" alt="" /></div>
              <div className="why-should-nbf-content-img why-should-nbf-content-inner">
                <h5>One-on-One</h5>
                <p>
                  One-on-One Interaction with freelancers plays a crucial role in building trust, ensuring clear communication, and achieving successful project outcomes
                </p>
              </div>
              <div className="why-should-nbf-content-img why-should-nbf-content-inner">
                <h5>Same Time zones</h5>
                <p>
                  Working with freelancers who share the same office hours promotes a collaborative work environment and enables them to attend team meetings just like regular employees
                  {/* One-on-One Interaction with freelancers plays a crucial role in building trust, ensuring clear communication, and achieving successful project outcomes */}
                </p>
              </div>
              <div className="why-should-nbf-content-img"><img src="/svg/why3.webp" alt="" /></div>
              <div className="why-should-nbf-content-img why-should-nbf-content-inner">
                <h5>Top Rated Freelancers</h5>
                <p>
                  We focus on providing high-quality freelancers to ensure a specialised skill set, greater dedication, and efficient collaboration for your project
                  {/* One-on-One Interaction with freelancers plays a crucial role in building trust, ensuring clear communication, and achieving successful project outcomes */}
                </p>
              </div>
              <div className="why-should-nbf-content-img"><img src="/svg/why4.webp" alt="" /></div>

            </div>

          </div>
        </div>
      )}




      {client_Id ? null : <div className="benefits">
        <div className="benefits-container">
          <div className="benefits-first">
            <h3  >Why Hire Local Freelancers?</h3>
            <p>There are many benefits to Hiring Local Freelancers </p>

          </div>
          <div className="benefits-second">
            <div className="benefits-second-inner benefits-second-content">
              <h4>Better communication</h4>
              <p>Local freelancers are more likely to be available during your working hours and to be able to communicate with you in person or over the phone. This can make it easier to collaborate and get your project done on time.</p>
            </div>
            <div className="benefits-second-inner">
              <img src="/svg/whylocal.webp" alt="" />
            </div>
            <div className="benefits-second-inner benefits-second-content">
              <h4>Better understanding of your needs</h4>
              <p>Local freelancers are more likely to understand your local market and your specific needs. This can help them to deliver a product or service that is tailored to your needs.</p>
            </div>
            <div className="benefits-second-inner benefits-second-content">
              <h4>Better trust & support</h4>
              <p>Hiring local freelancers can help you to build trust and relationships with other businesses in your community. This can be beneficial for future projects or collaborations.</p>
            </div>


          </div>
        </div>
      </div>}



































      {/* {client_Id ? (
        <div className="are-you-freelace mb-2 mb-md-5">
          <div style={{
            background: 'linear-gradient(92.95deg, green 0%, #bcddbb 66.42%)'
          }} className="are-you-freelace-container">
            <div className="are-you-freelace-first">
              <h2>Are You Freelancer?</h2>
              <p style={{ color: "white" }}>Join NBF and start earning without any hassle.</p>
              <button className='btn btn'><Link style={{ color: 'white' }} to={'/register-as-freelancer'}>Get Started</Link>  </button>
            </div>

          </div>
        </div>
      ) : recuiterId ? (
        <div className="are-you-freelace mb-5">
          <div style={{
            background: 'linear-gradient(92.95deg, #FCB349 0%, #FFF2D7 66.42%)'
          }} className="are-you-freelace-container">
            <div className="are-you-freelace-first">
              <h2>Are You Freelancer?</h2>
              <p style={{ color: "white" }}>Join NBF and start earning without any hassle.</p>
              <button className='btn btn'><Link style={{ color: 'white' }} to={'/register-as-freelancer'}>Get Started</Link>  </button>
            </div>

          </div>
        </div>
      ) : (
        <div className="are-you-freelace mb-5">
          <div className="are-you-freelace-container">
            <div className="are-you-freelace-first">
              <h2>Are You Freelancer?</h2>
              <p style={{ color: "white" }}>Join NBF and start earning without any hassle.</p>
              <button className='btn btn'><Link style={{ color: 'white' }} to={'/register-as-freelancer'}>Get Started</Link>  </button>
            </div>

          </div>
        </div>
      )} */}













    </>
  )
}

export default IntroduceFreelancer